const uuidRegexpPattern =
  '[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}'
const uuidRegexp = new RegExp(uuidRegexpPattern, 'gi')

export default [
  {
    path: '',
    name: 'CRMService.Contacts',
    component: () => import('../views/list')
  },
  {
    path: `:contact_id(${uuidRegexpPattern})`,
    component: () => import('../views/contact'),
    children: [
      {
        path: 'timeline',
        name: 'CRMService.Contacts.Detail.Timeline',
        component: () => import('../modules/timeline') 
      },
      {
        path: 'bpm',
        name: 'CRMService.Contacts.Detail.Bpm',
        component: () => import('../modules/bpm')
      },
      {
        path: 'relationships',
        name: 'CRMService.Contacts.Detail.Relationships',
        component: () => import('../modules/relationships')
      },
      {
        path: '',
        name: 'CRMService.Contacts.Detail',
        component: () => import('../modules/desktop')
      },
    ]
  }
]
/**
 * Contact url data
 * @param {*} contactId
 */
export function contactLink(contactId) {
  return {
    name: 'CRMService.Contacts.Detail',
    params: { contact_id: contactId }
  }
}



// WEBPACK FOOTER //
// ./src/apps/crm/contacts/routes/index.js